import { updateSpoTenant } from 'projects/angular-clarity/src/app/stores/client/powershell/spo/tenant/actions';
import { SpoTenant } from 'projects/angular-clarity/src/app/stores/client/powershell/spo/tenant/model';

export function Remediate(_tenant: string, data: Partial<SpoTenant>, schema: any) {
    if (schema.properties.PreventExternalUsersFromResharing.const === false) {
        return updateSpoTenant({ _tenant, data: { PreventExternalUsersFromResharing: false } });
    }

    if (schema.properties.PreventExternalUsersFromResharing.const === true) {
        return updateSpoTenant({ _tenant, data: { PreventExternalUsersFromResharing: true } });
    }
}
